import { Form, Input, Button, notification } from "antd";
import { AiOutlineUser, AiOutlinePhone } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { getToken, setToken } from "../../../utils/token";
import {
  useCompleteRegistrationMutation,
  useCompleteRegistrationWithEmailMutation,
} from "../../../services/auth.service";
import ChanelsLogo from "../../../assets/svg/chanels-logo.svg";

import BGImg from "../../../assets/png/v300batch2-nunoon-13.jpg";
import axios from "axios";
import { headers } from "../../../utils/headers";
import { isWWWhostname } from "../../../utils/helpers";
import { apiURL } from "../../../utils/axios";

const CompleteRegistration = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [completeRegistrationWithEmail, { isLoading }] =
    useCompleteRegistrationWithEmailMutation();
  const callerid = localStorage.getItem("spiral_username");

  const handleSubmit = async (values) => {
    try {
      const sessionid = await getToken("spiral_token");
      let res;

      if (callerid === "sysadmin") {
        // For sysadmin, include email in the payload
        const payload = { callerid, sessionid, ...values };
        // Use the completeRegistrationWithEmail mutation
        res = await completeRegistrationWithEmail(payload).unwrap();
      } else {
        // For non-sysadmin users, create payload without email field
        const { email, ...valuesWithoutEmail } = values;
        const payload = { callerid, sessionid, ...valuesWithoutEmail };
        // Use the regular axios post
        res = await axios.post(
          (isWWWhostname() === "xyz"
            ? apiURL.mmsUrlStaging
            : apiURL.mmsUrlDev) + "/auth/completeregistration",
          payload,
          headers
        );
        res = res.data; // Adjust to match the structure from the mutation
      }

      if (res.response === "failure") {
        return notification.error({
          message: "Operation failed. Please try again",
        });
      }

      if (res.response === "invalid session") {
        notification.error({ message: res.response });
        return navigate("/");
      }

      notification.success({
        message: "Registration complete. Please log in to continue.",
      });
      await setToken("spiral_registration", 1);
      navigate("/");
    } catch (err) {
      notification.error({ message: err.message || "An error occurred" });
    }
  };

  return (
    <div className="h-screen grid place-items-center">
      <div
        className="absolute top-0 left-0 w-screen h-screen"
        style={{
          background: `url(${BGImg}) center/cover no-repeat`,
          opacity: 0.1,
          backgroundAttachment: "fixed",
        }}
      />
      <div className="w-[95%] md:w-[450px] bg-white rounded-md shadow-md z-50 p-6">
        <div className="flex flex-col items-center justify-center">
          <div className="flex w-24 h-24 overflow-hidden">
            <img
              src={ChanelsLogo}
              alt="Chanels Logo"
              className="h-full scale-150 w-full object-cover"
            />
          </div>
        </div>
        <h2 className="text-center text-primary font-semibold text-2xl">
          Chanels
        </h2>
        <p className="text-center mt-2">
          Fill the fields below to complete registration.
        </p>
        <hr className="my-4" />

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          requiredMark={false}
          size="large"
        >
          <Form.Item
            required
            name="firstname"
            rules={[{ required: true, message: "Firstname is required" }]}
          >
            <Input
              prefix={<AiOutlineUser />}
              placeholder="Enter your firstname"
            />
          </Form.Item>

          <Form.Item
            required
            name="lastname"
            rules={[{ required: true, message: "Lastname is required" }]}
          >
            <Input
              prefix={<AiOutlineUser />}
              placeholder="Enter your lastname"
            />
          </Form.Item>

          {
            <Form.Item
              hidden={callerid === "sysadmin" ? false : true}
              name="email"
            >
              <Input
                prefix={<AiOutlineUser />}
                placeholder="Enter your email"
              />
            </Form.Item>
          }

          <Form.Item
            name="phone"
            rules={[
              { required: true, message: "Phone number is required" },
              { pattern: /^[0-9]+$/, message: "Only numbers are allowed" },
            ]}
          >
            <Input
              prefix={<AiOutlinePhone />}
              placeholder="Enter your phone number"
            />
          </Form.Item>

          <Form.Item>
            <Button
              className="!bg-primary !text-white !border-none"
              type="primary"
              htmlType="submit"
              block
              loading={isLoading}
            >
              Continue
            </Button>
          </Form.Item>
        </Form>

        <div className="text-center">
          <p>
            Already have an account?{" "}
            <Link to="/" className="underline text-secondary">
              Log in
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CompleteRegistration;
